import { render, staticRenderFns } from "./VantChangePopup.vue?vue&type=template&id=400eda9c&"
import script from "./VantChangePopup.vue?vue&type=script&lang=js&"
export * from "./VantChangePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports